import { render, staticRenderFns } from "./miniProgramIcon.vue?vue&type=template&id=3b16a929&scoped=true"
import script from "./miniProgramIcon.vue?vue&type=script&lang=js"
export * from "./miniProgramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16a929",
  null
  
)

export default component.exports